import * as React from 'react';
import styles from './uitk-utils.css';
import { classNames } from './classnames.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkThemeProvider = function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var config = props.config,
    children = props.children,
    _j = props.isColorThemeContainer,
    isColorThemeContainer = _j === void 0 ? false : _j;
  var themeClasses = getClassNameList(isColorThemeContainer && 'uitk-theme-provider-container', ((_a = config.lightMode) === null || _a === void 0 ? void 0 : _a.isThemeBase) && !((_b = config.lightMode) === null || _b === void 0 ? void 0 : _b.isGradient) && 'uitk-light-mode-is-base', ((_c = config.darkMode) === null || _c === void 0 ? void 0 : _c.isThemeBase) && !((_d = config.darkMode) === null || _d === void 0 ? void 0 : _d.isGradient) && 'uitk-dark-mode-is-base', ((_e = config.lightMode) === null || _e === void 0 ? void 0 : _e.isGradient) && 'uitk-light-mode-is-gradient', ((_f = config.darkMode) === null || _f === void 0 ? void 0 : _f.isGradient) && 'uitk-dark-mode-is-gradient');
  if (isColorThemeContainer) {
    return React.createElement("section", {
      "data-theme-light": (_g = config.lightMode) === null || _g === void 0 ? void 0 : _g.colorTheme,
      "data-theme-dark": (_h = config.darkMode) === null || _h === void 0 ? void 0 : _h.colorTheme,
      className: themeClasses
    }, children);
  }
  var newChildren = React.Children.map(children, function (child) {
    var _a, _b, _c;
    var displayName = (_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName;
    if (displayName === 'UitkCard' || displayName === 'UitkSheet') {
      return React.cloneElement(child, {
        className: themeClasses,
        'data-theme-light': (_b = config.lightMode) === null || _b === void 0 ? void 0 : _b.colorTheme,
        'data-theme-dark': (_c = config.darkMode) === null || _c === void 0 ? void 0 : _c.colorTheme
      });
    }
  });
  return React.createElement(React.Fragment, null, newChildren);
};
export { UitkThemeProvider };